import EndorsementChangeEndorsementDatePopup from './EndorsementChangeEndorsementDatePopup';
import EndorsementCoordinatesSelectionCommercialPopup from './EndorsementCoordinatesSelectionCommercialPopup';
import EndorsementCoordinatesSelectionPersonalPopup from './EndorsementCoordinatesSelectionPersonalPopup';
import EndorsementEndorsementPremiumBreakdownPopup from './EndorsementEndorsementPremiumBreakdownPopup';
import EndorsementEndorsementRenewalPremiumBreakdownPopup from './EndorsementEndorsementRenewalPremiumBreakdownPopup';
import EndorsementPremiumCalculationInfoPopup from './EndorsementPremiumCalculationInfoPopup';
import EndorsementPreSubmissionAcknowledgementsPopup from './EndorsementPreSubmissionAcknowledgementsPopup';

export {
	EndorsementChangeEndorsementDatePopup,
	EndorsementCoordinatesSelectionCommercialPopup,
	EndorsementCoordinatesSelectionPersonalPopup,
	EndorsementEndorsementPremiumBreakdownPopup,
	EndorsementEndorsementRenewalPremiumBreakdownPopup,
	EndorsementPremiumCalculationInfoPopup,
	EndorsementPreSubmissionAcknowledgementsPopup,
};